var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shop-order-history-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-3f041a10!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shop-order-history-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShopOrderHistoryList.vue
// module id = 711
// module chunks = 1